import { MessageOverview } from "../../../../../../../../components/Messages";

const ProxyMessageOverview = () => {
  return <MessageOverview />;
};

export default ProxyMessageOverview;
